import React from 'react'
import { Route, Switch } from 'react-router-dom'

import Home from './Home'
import Details from './Details'
import NotFound from './NotFound'
import getConstants from '../constants'
import { canUseDOM } from '../utils'

export const supportedRoutes = {
  home: '/',
  storeDetail: '/detail/:storeId',
}

/** Ensure the language matches the country and redirects otherwise */
const ensureLanguage = () => {
  const {
    LANGUAGE: languageFromPath,
    LANGUAGES: allLanguages,
    COUNTRY: country,
  } = getConstants()
  const languages = Object.values(allLanguages)
  if (languages.includes(languageFromPath)) {
    return
  }

  const countryBaseRegEx = new RegExp(`/${country}.+`)
  window.location.assign(
    window.location.pathname.replace(
      countryBaseRegEx,
      `/${country}/${Object.values(languages)[0]}`,
    ),
  )
}

const Routes = () => {
  if (canUseDOM) {
    ensureLanguage()
  }
  return (
    <Switch>
      <Route path={supportedRoutes.home} exact component={Home} />
      <Route path={supportedRoutes.storeDetail} component={Details} />

      <Route path="/shell.html" component={() => null} />
      <Route component={NotFound} />
    </Switch>
  )
}

export default Routes
